<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';

const { t } = useI18n();

const fairDistributionLimit = defineModel('fairDistributionLimit', {
  type: Number,
  default: 100,
  set(value) {
    return Number(value) || 0;
  },
});

</script>

<template>
  <div
    class="flex items-center gap-3 bg-n-solid-1 p-4 outline outline-1 outline-n-weak rounded-xl"
  >
    <label class="text-sm font-medium text-n-slate-12">
      {{
        t(
          'ASSIGNMENT_POLICY.AGENT_ASSIGNMENT_POLICY.FORM.FAIR_DISTRIBUTION.INPUT_MAX'
        )
      }}
    </label>
    <div class="flex-1 max-w-[10rem]">
      <Input
        v-model="fairDistributionLimit"
        type="number"
        placeholder="5"
        max="100000"
        class="w-full"
      />
    </div>
  </div>
</template>
